<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="icon">
        <img :src="'static/' + row.icon + '/4/3.gif'" style="width: 30px" />
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      width="1000"
      ref="formModel"
    >
      <Input
        v-model="item.ono"
        placeholder="请选择"
        slot="ono"
        @on-focus="openForm = true"
      ></Input>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <Modal v-model="openForm" title="订单号" footer-hide width="1000">
      <dingdanhao
        :scan="true"
        @obj="
          item.ono = $event.no;
          openForm = false;
        "
      ></dingdanhao>
    </Modal>
  </div>
</template>
<script>
import dingdanhao from "./xitongkaidan.vue";
export default {
  components: { dingdanhao },
  data() {
    return {
      isAdd: false,
      openForm: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        tradeType: "出口",
        bgType: "报关",
        mode: "客户自报",
        ckPort: "",
        bgPerson: "",
        wfNo: "",
        tel: "",
        filesNum: 1,
        jkPort: "",
        qgCompany: "",
        qgAddress: "",
        qgNo: "",
        sixNo: "",
        remark: "",
        ono: "",
      },

      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        startTime: new Date(2023, 4, 1).getTime(),
        endTime: new Date(2023, 6, 1).getTime(),
        no: "",
        carNo: "",
        driver: "",
        sixOno: "",
        bpMode: 1,
        carType: "",
        tradeType: "出口",
        addressD: "",
        addressS: "",
        status: 0, //0-分单配载, 1-待发车，2-已发车，3 运输中，4 已送达,5 未签收,6 已签收, 7-取消, 8-异常
      },
      total: 0,
      categorys: [],
      forms: [
        {
          title: "订单号",
          key: "ono",
          slotForm: "ono",
          required: true,
        },
        {
          title: "贸易类型",
          key: "tradeType",
          required: true,
          val: "",
          type: "Select",
          selectItems: ["进口", "出口"],
        },
        {
          title: "报关类型",
          key: "bgType",
          required: true,
          val: "",
          type: "Select",
          selectItems: ["报关", "清关", "舱单"],
        },
        {
          title: "报关方式",
          key: "mode",
          required: true,
          val: "",
          type: "Select",
          selectItems: ["客户自报", "我司代理"],
        },
        {
          title: "出口口岸",
          key: "ckPort",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "报关员",
          key: "bgPerson",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "无缝号码",
          key: "wfNo",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "联系电话",
          key: "tel",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "文件数量",
          key: "filesNum",
          required: false,
          val: 0,
          type: "InputNumber",
        },
        {
          title: "进口口岸",
          key: "jkPort",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "清关公司",
          key: "qgCompany",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "清关地址",
          key: "qgAddress",
          required: false,
          val: "",
          type: "selectAddMap",
        },
        {
          title: "清关号码",
          key: "qgNo",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "六联单号",
          key: "sixNo",
          required: false,
          val: "",
          type: "Select",
          selectItems: ["NS2455788654", "NS2455788653"],
        },
        {
          title: "备注信息",
          key: "remark",
          required: false,
          val: "",
          type: "Input",
        },
      ],
      searchForms: [
        {
          title: "六联单号",
          key: "sixOno",
          type: "Input",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "运单号",
          key: "tno",
          type: "Input",
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/ordersCustoms/list",
        //url: this.axios.ipPort + "/cloud-tms-server-omc/ordersCustoms/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-omc/ordersCustoms/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-omc/ordersCustoms/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-omc/ordersCustoms/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 130,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);

    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/guanwuchuli.vue